// extracted by mini-css-extract-plugin
export default {"unlockText":"styles_unlockText__FxwMA","pills":"styles_pills__IqXht","pill":"styles_pill__3bLed"};